export default __webpack_public_path__ + "static/media/MKR.a8589c3c.svg";